export const CONTACT_SELLER_RECAPTCHA_EVENT = 'CONTACT_SELLER'
